import {TextField} from "@mui/material";
import {FC, FocusEvent, MouseEvent, ReactNode} from "react";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    value: string,
    onChange?: (value: string) => void,
    error?: boolean,
    errorMessage?: string,
    name?: string,
    fullWidth?: boolean,
    size?: 'small',
    label?: string,
    multiline?: boolean,
    rows?: number,
    disabled?: boolean,
    InputProps?: {
        startAdornment?: ReactNode,
        endAdornment?: ReactNode,
    },
    inputProps?: {
        type?: 'number' | 'tel' | 'text' | 'password',
        min?: number,
        max?: number,
    },
    sx?: SxType,
    placeholder?: string
    onClick?: (event: MouseEvent<HTMLDivElement>) => void
    onFocus?: (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    autoFocus?: boolean
}

const InputCustom: FC<IProps> = ({
                                     value,
                                     onChange,
                                     error,
                                     name,
                                     fullWidth = true,
                                     size = 'small',
                                     label,
                                     multiline,
                                     rows,
                                     disabled,
                                     errorMessage,
                                     InputProps,
                                     inputProps,
                                     placeholder,
                                     sx = {},
                                     onClick,
                                     onFocus,
                                     autoFocus,
                                 }) => {

    const inputCustomSx = {
        borderColor: '#00000033',
        "& .MuiInputBase-root": {
            borderRadius: '8px',
            paddingRight: '20px',
            '.lightTheme &': {
                background: disabled ? 'transparent' : '#fff',
            }
        },
        '.lightTheme & .MuiFormLabel-root': {
            color: 'black'
        },
        ...sx,
    }
    const handleChange = (event: any) => {
        onChange && onChange(event.target.value as string)
    }

    return (
        <TextField
            disabled={disabled}
            rows={rows}
            fullWidth={fullWidth}
            size={size}
            label={label}
            value={value}
            onChange={handleChange}
            error={error}
            name={name}
            sx={inputCustomSx}
            multiline={multiline}
            helperText={error && errorMessage}
            placeholder={placeholder}
            InputProps={{
                startAdornment: InputProps?.startAdornment,
                endAdornment: InputProps?.endAdornment,
            }}
            inputProps={inputProps}
            onClick={onClick}
            onFocus={onFocus}
            autoFocus={autoFocus}
        />
    )

}

export default InputCustom;